import BaseRepository from "../../../lib/itn-ui-kit/services/repositories/base-repository";
import KPIDashboardModel from "../../models/kpi-dashboard";

export default class KPIMetricRepository extends BaseRepository {
  static modelClass = KPIDashboardModel;
  modelName = "kpi-dashboard";
}
